import { defineMessages } from "react-intl";
import hooks from "../../node_modules/moment/dist/moment.js";
import { of, from } from "rxjs";
import { filter, catchError } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { ServerResponseStatus, maxPageSize } from "../../api/types.js";
import "immer";
import { UserProfile } from "../../contract/pam.js";
import { momentToTimestampSeconds, formatDate } from "../../utils/date.js";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { mergeMap, map, switchMap } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "rxjs/ajax";
import { userProfileMappingKeys } from "./mapper.js";
import { UserProfileDownloadModel } from "./types.js";
import "react-redux";
import "../../user-settings/components/UserSettingsProvider.js";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "../../auto-mapper/AutoMapperProvider.js";
import "../../redux-folder/async-actions/actions.js";
import "../../redux-folder/async-actions/selectors.js";
import "../../intl/shared-resources/serverResponse.js";
import { BaseEpicsBuilder } from "../../redux-folder/epicsBuilder.js";
import "../../redux-folder/actions.js";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/async-actions/reducers.js";
import "../../redux-folder/download/actions.js";
import "../../redux-folder/download/epics.js";
import "../../ioc-container/inversifyProvider.js";
import "react-hook-form";
import "fast-deep-equal";
import "normalizr";
import "fast-deep-equal/es6";
import "redux";
import { getEntityActions } from "../../redux-folder/entity/actions.js";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "./components/DataGrid.js";
import { userProfileActions } from "./actions.js";
import { AgentRevenueShareViewModelTypeName } from "./constants.js";
import "./components/Platform.js";
import "../../components/download/DownloadCsvButton.js";
import "../../components/download/DownloadTemplate.js";
import "../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../components/input/validation.js";
import "../../components/input/DatePicker.js";
import "../../components/input/DateRangePicker.js";
import "../../components/input/StyledInput.js";
import "../../components/input/FormInput.js";
import "../../components/input/StyledFormInputHoc.js";
import "../../components/input/DateSinglePicker.localize.js";
import "../../components/input/hooks.js";
import "@mui/material";
import "../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../components/filter/date-filter/DateFilter.js";
import "../../components/filter/TextFilterWithDropdown.js";
import "../../components/filter/MultiStepFilterDrawer.js";
import "../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../components/select/Select.js";
import "../../components/filter/TextFilter.js";
import "../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../components/filter/dateRangeFilter/localized.js";
import "../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../components/filter/MultiStepFilterApplyButton.js";
import "../../components/filter/MultiStepFilterInput.js";
import "../../components/filter/MultiStepFilterHoc.js";
import "../../components/chip/ChipRenderer.js";
import "../../components/select/selectStyle.js";
import "../../components/select/MultiSelectFooter.js";
import "../../components/select/MultiSelect.js";
import "../../components/select/MultiSelectItem.js";
import "../../components/select/SelectArrowIcon.js";
import "../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../components/select/SingleSelect.js";
import "../../components/select/MultiSelectWithExclude.js";
import "../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../components/filter/PhoneFilter.js";
import "../brand-license/constants.js";
import "@automapper/core";
import "../country/components/CountryFilter.js";
import "../brand-license/components/BrandProvider.js";
import "../../components/alerts/NoAccessInfoMessage.js";
import "../brand-license/components/LicenseSelect.js";
import "../brand-license/components/BrandSelect.js";
import "../../components/circle-box/CircleBoxWithText.js";
import "../../components/label/EmptyLabel.js";
import "../../components/label/LabelHoc.js";
import "../../components/tooltip/Tooltip.js";
import "../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../style/hooks.js";
import "../../components/circle-box/CircleBox.js";
import "./components/Filters.js";
import "./components/P2PStatusCell.js";
import "./components/UserDetailsWDBalance.js";
import "./components/ReferralLinkButton.js";
import "./components/PlayerIdAutocomplete.js";
import { fileActions } from "../../redux-folder/file/actions.js";
import { messageActions } from "../../redux-folder/message/actions.js";
const userProfileEpicLocalized = defineMessages({
  downloadFailureMessage: {
    id: "UserProfileActionsEpicsBuilder_downloadFailureMessage",
    defaultMessage: "Failed to download"
  },
  downloadMaxPageSizeErrorMessage: {
    id: "UserProfileActionsEpicsBuilder_downloadMaxPageSizeErrorMessage",
    defaultMessage: "Total count of downloaded items cannot be more than {maxPageSize}"
  },
  updatePlayerIdSuccess: {
    id: "UserProfileActionsEpicsBuilder_updatePlayerIdSuccess",
    defaultMessage: "Agent Player ID successfully changed to {uid}"
  },
  updatePlayerIdFailure: {
    id: "UserProfileActionsEpicsBuilder_updatePlayerIdFailure",
    defaultMessage: "Failed to change Agent Player ID"
  },
  noParentAgentRevenueShare: {
    id: "UserProfileActionsEpicsBuilder_noParentAgentRevenueShare",
    defaultMessage: "The parent agent doesn't have revenue share %"
  },
  invalidSubagentRevenueShare: {
    id: "UserProfileActionsEpicsBuilder_invalidSubagentRevenueShare",
    defaultMessage: "You cannot set a revenue share % higher than parent agent"
  },
  updateAgentRevenueShareSuccess: {
    id: "UserProfileActionsEpicsBuilder_updateAgentRevenueShareSuccess",
    defaultMessage: "Agent Revenue Share successfully updated"
  },
  updateAgentRevenueShareFailure: {
    id: "UserProfileActionsEpicsBuilder_updateAgentRevenueShareFailure",
    defaultMessage: "Failed to update Agent Revenue Share"
  },
  keycloakConnectionExists: {
    id: "UserProfileActionsEpicsBuilder_keycloakConnectionExists",
    defaultMessage: "Keycloak connection already exists for player {playerId}. Please remove this agent from keycloak and try again."
  },
  updateNonWdBalanceSuccess: {
    id: "UserProfileActionsEpicsBuilder_updateNonWDBalanceSuccess",
    defaultMessage: "Non-Withdrawable Balance succcessfully updated"
  },
  updateNonWdBalanceFailure: {
    id: "UserProfileActionsEpicsBUilder_updateNonWDBalanceFailure",
    defaultMessage: "Failed to update Non-Withdrawable Balance"
  },
  userNotFound: {
    id: "UserProfileActionsEpicsBUilder_userNotFound",
    defaultMessage: "User not found"
  },
  nonWDBalanceCannotExceedTotalBalance: {
    id: "UserProfileActionsEpicsBUilder_nonWDBalanceCannotExceedTotalBalance",
    defaultMessage: "The Non-Withdrawable Balance can’t exceed the Total Balance"
  },
  nonWDBalanceCannotBeNegative: {
    id: "UserProfileActionsEpicsBUilder_nonWDBalanceCannotBeNegative",
    defaultMessage: "The Non-Withdrawable Balance can’t be negative"
  },
  copyReferralLinkSuccess: {
    id: "UserProfileActionsEpicsBuilder_copyReferralLinkSuccess",
    defaultMessage: "Copied"
  },
  copyReferralLinkFailure: {
    id: "UserProfileActionsEpicsBuilder_copyReferralLinkFailure",
    defaultMessage: "Failed to copy"
  }
});
class UserProfileEpicsBuilder extends BaseEpicsBuilder {
  _service;
  _mapper;
  _fileAdapter;
  _entityActions;
  _userProfileEntityType = "UserProfile";
  constructor(service, fileAdapter, mapper) {
    super();
    this._service = service;
    this._fileAdapter = fileAdapter;
    this._mapper = mapper;
    this._entityActions = getEntityActions();
  }
  buildEpicList() {
    return [
      this.buildDownloadEpic(),
      this.buildDownloadSuccessEpic(),
      this.buildDownloadFailureEpic(),
      this.buildUpdatePlayerIdRequestEpic(),
      this.buildUpdatePlayerIdSuccessEpic(),
      this.buildUpdatePlayerIdFailureEpic(),
      this.buildUpdateRevenueShareRequestEpic(),
      this.buildUpdateRevenueShareSuccessEpic(),
      this.buildUpdateRevenueShareFailureEpic(),
      this.buildUpdateNonWDBalanceRequestEpic(),
      this.buildUpdateNonWDBalanceSuccessEpic(),
      this.buildUpdateNonWDBalanceFailureEpic(),
      this.buildCopyReferralLinkRequestEpic(),
      this.buildCopyReferralLinkSuccessEpic(),
      this.buildCopyReferralLinkFailureEpic()
    ];
  }
  /**
   * @deprecated
   * <p>Should be removed. Use bo-operation/features/block-download</p>
   */
  buildDownloadEpic() {
    return (actions$) => actions$.pipe(
      filter(isActionOf(userProfileActions.download.request)),
      mergeMap((action) => {
        const { filter: filter2, fields, filename, worksheetKeys, headers } = action.payload;
        const fetchPayload = {
          type: this._userProfileEntityType,
          filter: filter2,
          fields
        };
        const failureActionObservable = of(
          userProfileActions.download.failure({ message: userProfileEpicLocalized.downloadFailureMessage, mode: "error" })
        );
        return this._service.get(fetchPayload).pipe(
          mergeMap((response) => {
            let result;
            if (response?.status === ServerResponseStatus.Success) {
              if (response?.responsePayload?.total <= maxPageSize) {
                const worksheetData = response.responsePayload?.items?.map((i) => {
                  const downloadModel = this._mapper.map(i, UserProfile, UserProfileDownloadModel);
                  const latestRevenueShareHistory = this._mapper.map(
                    (i?.agent_info?.agent_revenue_share_list ?? []).at(-1),
                    userProfileMappingKeys.agentRevenueShare,
                    userProfileMappingKeys.agentRevenueShareViewModel
                  );
                  this._mapper.mutate(
                    latestRevenueShareHistory,
                    downloadModel,
                    AgentRevenueShareViewModelTypeName,
                    UserProfileDownloadModel
                  );
                  return downloadModel;
                });
                result = this._fileAdapter.createFile(worksheetData, worksheetKeys, headers).pipe(
                  map((arrayBuffer) => userProfileActions.download.success({ arrayBuffer, filename })),
                  catchError(() => failureActionObservable)
                );
              } else {
                result = of(
                  userProfileActions.download.failure({
                    message: userProfileEpicLocalized.downloadMaxPageSizeErrorMessage,
                    values: { maxPageSize: maxPageSize.toString() },
                    mode: "error"
                  })
                );
              }
            } else {
              result = failureActionObservable;
            }
            return result;
          }),
          catchError(() => failureActionObservable)
        );
      })
    );
  }
  /**
   * @deprecated
   * <p>Should be removed. Use bo-operation/features/block-download</p>
   */
  buildDownloadSuccessEpic() {
    return (actions$) => actions$.pipe(
      filter(isActionOf(userProfileActions.download.success)),
      map((action) => {
        const { filename, arrayBuffer } = action.payload;
        return fileActions.download({
          file: new Blob([arrayBuffer]),
          title: filename,
          type: "csv"
        });
      })
    );
  }
  /**
   * @deprecated
   * <p>Should be removed. Use bo-operation/features/block-download</p>
   */
  buildDownloadFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.download.failure)),
      map((action) => messageActions.saveMessage(action.payload))
    );
  }
  // TODO: [BO-2903] Leave single epic
  buildUpdatePlayerIdRequestEpic() {
    const handlePlayerIdUpdate = (payload) => {
      if (payload.newPlayerId && payload.oldPlayerId && payload.oldPlayerId !== payload.newPlayerId) {
        return this.getRemoveAgentInfoRequest(payload).pipe(
          mergeMap(
            (response) => response.status === ServerResponseStatus.Success ? this.getAddAgentInfoRequest(payload) : of(response)
          )
        );
      } else if (payload.newPlayerId && payload.oldPlayerId && payload.oldPlayerId === payload.newPlayerId) {
        return this.getAddAgentInfoRequest(payload);
      } else if (payload.oldPlayerId) {
        return this.getRemoveAgentInfoRequest(payload);
      } else if (payload.newPlayerId) {
        return this.getAddAgentInfoRequest(payload);
      } else {
        return of({
          status: ServerResponseStatus.Success,
          requestPayload: null,
          responsePayload: null
        });
      }
    };
    const updatePlayerIdRequestEpic = this.buildRequestEpic(
      userProfileActions.updatePlayerId,
      handlePlayerIdUpdate
    );
    return updatePlayerIdRequestEpic;
  }
  getRemoveAgentInfoRequest(payload) {
    return this._service.updateAgentInfo({
      uid: payload.oldPlayerId,
      agent_info: null
    });
  }
  getAddAgentInfoRequest(payload) {
    return this._service.updateAgentInfo({
      uid: payload.newPlayerId,
      agent_info: {
        bo_agent_id: payload.agentId,
        agent_granted_ts: { seconds: momentToTimestampSeconds(hooks()) },
        default_agent_revenue_share_history: payload.revenueShare
      }
    });
  }
  buildUpdatePlayerIdSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.updatePlayerId.success)),
      mergeMap((res) => {
        let result = of();
        if (res.payload.responsePayload) {
          const { uid, agent_info } = res.payload.responsePayload;
          const updatedItem = { agent_info };
          result = of(
            messageActions.saveMessage({
              message: userProfileEpicLocalized.updatePlayerIdSuccess,
              values: { uid },
              mode: "success"
            }),
            this._entityActions.updateItem({
              type: this._userProfileEntityType,
              id: uid,
              updatedItem
            })
          );
        }
        return result;
      })
    );
  }
  buildUpdatePlayerIdFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.updatePlayerId.failure)),
      map((res) => {
        const { errorMessage, values } = this.getUpdateUserErrorMessage(res.payload.errors?.[0]);
        return messageActions.saveMessage({ message: errorMessage, values, mode: "error" });
      })
    );
  }
  getUpdateUserErrorMessage(serverError, defaultMessage) {
    const error = { errorMessage: defaultMessage ?? userProfileEpicLocalized.updatePlayerIdFailure };
    const validationErrors = serverError?.validation_errors;
    const code = serverError?.code;
    if (validationErrors) {
      error.errorMessage = validationErrors;
    } else if (code === "20000063") {
      error.errorMessage = userProfileEpicLocalized.noParentAgentRevenueShare;
    } else if (code === "20000064") {
      error.errorMessage = userProfileEpicLocalized.invalidSubagentRevenueShare;
    } else if (code === "KEYCLOAK_CONNECTION_EXISTS") {
      error.errorMessage = userProfileEpicLocalized.keycloakConnectionExists;
      error.values = { playerId: serverError?.data?.uid };
    }
    return error;
  }
  buildUpdateRevenueShareRequestEpic() {
    return this.buildRequestEpic(
      userProfileActions.updateAgentRevenueShare,
      (payload) => this._service.updateAgentRevenueShare(payload)
    );
  }
  buildUpdateRevenueShareSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.updateAgentRevenueShare.success)),
      mergeMap((res) => {
        let result = of();
        const { agentId, agentRevenueShare } = res.payload.requestPayload;
        const updatedItem = {
          agent_info: {
            agent_revenue_share_list: [
              {
                active_since: formatDate(/* @__PURE__ */ new Date(), "iso-date", false, false),
                casino_share: agentRevenueShare.casino_share,
                commission_subtypes: agentRevenueShare.commission_subtypes,
                spins: agentRevenueShare.spins,
                poker_mtt: agentRevenueShare.poker_mtt,
                sports: agentRevenueShare.sports,
                poker_cash: {
                  nlh_sd: agentRevenueShare.poker_cash,
                  plo: agentRevenueShare.poker_cash_plo
                }
              }
            ]
          }
        };
        result = of(
          messageActions.saveMessage({
            message: userProfileEpicLocalized.updateAgentRevenueShareSuccess,
            mode: "success"
          }),
          this._entityActions.updateItem({
            type: this._userProfileEntityType,
            id: agentId,
            updatedItem
          })
        );
        return result;
      })
    );
  }
  buildUpdateRevenueShareFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.updateAgentRevenueShare.failure)),
      map(
        (res) => messageActions.saveMessage({
          message: this.getUpdateUserErrorMessage(
            res.payload.errors?.[0],
            userProfileEpicLocalized.updateAgentRevenueShareFailure
          ).errorMessage,
          mode: "error"
        })
      )
    );
  }
  buildUpdateNonWDBalanceRequestEpic() {
    return this.buildRequestEpic(
      userProfileActions.updateNonWDBalance,
      (payload) => this._service.updateNonWdBalance(payload)
    );
  }
  buildUpdateNonWDBalanceSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.updateNonWDBalance.success)),
      mergeMap(({ payload }) => {
        const updatedItem = {
          finance: {
            non_withdrawable_balance: payload?.requestPayload?.amount
          }
        };
        return of(
          messageActions.saveMessage({
            message: userProfileEpicLocalized.updateNonWdBalanceSuccess,
            mode: "success"
          }),
          this._entityActions.updateItem({
            type: this._userProfileEntityType,
            id: payload?.requestPayload?.uid,
            updatedItem
          })
        );
      })
    );
  }
  buildUpdateNonWDBalanceFailureEpic() {
    const errorMessageMapping = {
      CAN_NOT_BE_NEGATIVE_NUMBER: userProfileEpicLocalized.nonWDBalanceCannotBeNegative,
      PLAYER_NOT_FOUND: userProfileEpicLocalized.userNotFound,
      EXCEED_TOTAL_BALANCE: userProfileEpicLocalized.nonWDBalanceCannotExceedTotalBalance
    };
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.updateNonWDBalance.failure)),
      map(
        (res) => messageActions.saveMessage({
          message: errorMessageMapping[res.payload.errors?.[0]?.code] ?? userProfileEpicLocalized.updateNonWdBalanceFailure,
          mode: "error"
        })
      )
    );
  }
  buildCopyReferralLinkRequestEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.copyReferralCode.request)),
      mergeMap(
        ({ payload, meta }) => this._service.get({
          fields: ["referral.personal_referral_link"],
          filter: `?uid=${payload}`,
          type: this._userProfileEntityType
        }).pipe(
          switchMap((res) => {
            const failedAction = userProfileActions.copyReferralCode.failure(res, meta);
            let result = of(failedAction);
            const link = res?.responsePayload?.items?.[0]?.referral?.personal_referral_link;
            if (res.status === ServerResponseStatus.Success && link?.length > 0) {
              result = from(navigator.clipboard.writeText(link)).pipe(
                map(() => userProfileActions.copyReferralCode.success(res, meta)),
                catchError(() => of(failedAction))
              );
            }
            return result;
          })
        )
      )
    );
  }
  buildCopyReferralLinkSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.copyReferralCode.success)),
      map(
        () => messageActions.saveMessage({
          message: userProfileEpicLocalized.copyReferralLinkSuccess,
          mode: "success"
        })
      )
    );
  }
  buildCopyReferralLinkFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(userProfileActions.copyReferralCode.failure)),
      map(
        () => messageActions.saveMessage({
          message: userProfileEpicLocalized.copyReferralLinkFailure,
          mode: "error"
        })
      )
    );
  }
}
export {
  UserProfileEpicsBuilder,
  userProfileEpicLocalized
};
//# sourceMappingURL=epics.js.map
